import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function SearchSuggest(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("g", {
    clipPath: "url(#search-suggest)"
  }, React.createElement("path", {
    d: "M14.6566 7.36566C14.6566 10.8813 11.8066 13.7313 8.29095 13.7313C4.7753 13.7313 1.92529 10.8813 1.92529 7.36566C1.92529 3.85 4.7753 1 8.29095 1C11.8066 1 14.6566 3.85 14.6566 7.36566Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M20.0171 19.0923L13.0596 12.1348",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "search-suggest"
  }, React.createElement("rect", {
    x: 0.925293,
    width: 20,
    height: 20,
    fill: "white"
  }))));
}

export { SearchSuggest };
//# sourceMappingURL=SearchSuggest.js.map